import React from 'react'
import { Button } from "../button/Button"
import styles from "./SparePartCard.module.css"
export function SparePartCard({ img, text, width, height, link }) {
    return (
        <div className={`${styles.card} ${styles[width]}`}>
            <picture>
                <img loading='lazy' className={`${styles.image}  ${styles[width]}   ${styles[height]}`} src={`${img}`} alt={`${text}`} />
            </picture>
            <Button variant={"dark-blue"} link={`${link}`} behaviour="link">{text}</Button>
        </div>
    )
}
